export function NavigationMenuLoader() {
	return (
		<>
			<div className="edit-site-sidebar-navigation-screen-navigation-menus__placeholder" />
			<div className="edit-site-sidebar-navigation-screen-navigation-menus__placeholder" />
			<div className="edit-site-sidebar-navigation-screen-navigation-menus__placeholder" />
		</>
	);
}
